import React from 'react';
import GameSession from '../../Common/GameSession';

const AgentPlayerGameSession = ({ playerID }) => {
    return <GameSession AgentPlayer={true} playerID={playerID} />
};

export default AgentPlayerGameSession;
